<div class="popup-table" *ngIf="data?.length; else noDataTemplate">
  <table>
    <thead>
      <tr>
        <th *ngFor="let key of objectKeys(data[0])">
          {{ key | titleCaseWithoutUnderscorePipe }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of data">
        <td *ngFor="let key of objectKeys(row)">
          {{ row[key] }}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #noDataTemplate>
  <div class="no-data-message">No data available.</div>
</ng-template>
